import { render, staticRenderFns } from "./QuoteMilestonesLegacy.vue?vue&type=template&id=a7a74e70&"
import script from "./QuoteMilestonesLegacy.vue?vue&type=script&lang=js&"
export * from "./QuoteMilestonesLegacy.vue?vue&type=script&lang=js&"
import style0 from "./QuoteMilestonesLegacy.vue?vue&type=style&index=0&id=a7a74e70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports